import {
  IRecognitionCreateProps,
  IRecognitionProps,
  IRecognitionSimpleProps,
  IRecognitionUpdateProps,
} from '../types';
import { IIntegrationProps } from '../../IntegrationService/types';
import { bool } from 'yup';

export interface IResponsibleRecognitionProps extends IRecognitionProps {
  email: string;
  password?: string;
  gender: ResponsibleGenderTypes;
  integrations: IIntegrationProps[];
  studentIds: number[];
  tempStudentsIds: number[] ;
  carPlates: string[];
  vehicleTags: string[];
  telegramId?: string;
  deviceToken?: string;
  uc?: string[] | null;
  freePass?: boolean | null;

}

export interface IResponsibleRecognitionSimpleProps
  extends IRecognitionSimpleProps {
  gender: ResponsibleGenderTypes;
}

export interface IResponsibleRecognitionCreateProps
  extends IRecognitionCreateProps {
  password?: string;
  email?: string;
  studentIds: number[]
  tempStudentsIds?: number[] ;
  gender: string;
  carPlates: string[];
  vehicleTags?: string[];
  telegramId?: string;
  uc?: string[] | null;
  freePass?: boolean | null;

}

export interface IResponsibleRecognitionUpdateProps
  extends IRecognitionUpdateProps {
  password?: string;
  email?: string;
  studentIds: number[];
  tempStudentsIds?: number[];
  gender: string;
  carPlates: string[];
  vehicleTags?: string[];
  telegramId?: string;
  uc?: string[] | null;
  freePass?: boolean | null;

}

export interface IResponsibleRecognitionUpdateParams {
  id: number;
  data: IResponsibleRecognitionUpdateProps;
}

export enum ResponsibleGenderTypes {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}
